import { render, staticRenderFns } from "./programarest-add.vue?vue&type=template&id=cfb889b2"
import script from "./programarest-add.vue?vue&type=script&lang=js"
export * from "./programarest-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports